module.exports = __webpack_public_path__ + "img/beta-unsplash-01.64838a79.jpg";